var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("SoliForm", {
    ref: "contactForm",
    attrs: {
      persistent: true,
      title: _vm.programInquiry ? "Great Choice!" : "Contact Us!",
      textSubtitle: _vm.programInquiry
        ? `We're excited to get you started in ${_vm.programInquiry}! Please submit your information and a community manager will get back to you shortly.`
        : `We'll get back to you shortly`,
    },
    on: {
      submit: function ($event) {
        return _vm.submitContactForm()
      },
      reset: function ($event) {
        return _vm.resetContactForm()
      },
    },
    scopedSlots: _vm._u([
      {
        key: "body",
        fn: function () {
          return [
            _c(
              "v-container",
              { staticClass: "px-0" },
              [
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "6" } },
                      [
                        _c("v-text-field", {
                          staticClass: "py-05",
                          attrs: {
                            "prepend-inner-icon": "person",
                            label: "First Name",
                            outlined: "",
                            rules: [(v) => !!v || "First name is required"],
                            dense: "",
                            "hide-details": "",
                          },
                          model: {
                            value: _vm.contactForm.first_name,
                            callback: function ($$v) {
                              _vm.$set(_vm.contactForm, "first_name", $$v)
                            },
                            expression: "contactForm.first_name",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "6" } },
                      [
                        _c("v-text-field", {
                          staticClass: "py-05",
                          attrs: {
                            "prepend-inner-icon": _vm.$vuetify.breakpoint.xs
                              ? "person"
                              : null,
                            label: "Last Name",
                            outlined: "",
                            rules: [(v) => !!v || "Last name is required"],
                            dense: "",
                          },
                          model: {
                            value: _vm.contactForm.last_name,
                            callback: function ($$v) {
                              _vm.$set(_vm.contactForm, "last_name", $$v)
                            },
                            expression: "contactForm.last_name",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("BookingEmail", {
                  model: {
                    value: _vm.contactForm.email,
                    callback: function ($$v) {
                      _vm.$set(_vm.contactForm, "email", $$v)
                    },
                    expression: "contactForm.email",
                  },
                }),
                _vm._v(" "),
                _c("SoliPhone", {
                  attrs: {
                    errors: _vm.errors.phone,
                    hideDetails: _vm.programInquiry ?? false,
                  },
                  on: {
                    input: function ($event) {
                      return _vm.$emit("input", $event)
                    },
                  },
                  model: {
                    value: _vm.contactForm.phone,
                    callback: function ($$v) {
                      _vm.$set(_vm.contactForm, "phone", $$v)
                    },
                    expression: "contactForm.phone",
                  },
                }),
                _vm._v(" "),
                !_vm.programInquiry
                  ? _c("v-textarea", {
                      staticClass: "soli-round",
                      attrs: {
                        outlined: "",
                        label: "Any questions?",
                        "hide-details": "auto",
                      },
                      model: {
                        value: _vm.contactForm.comments,
                        callback: function ($$v) {
                          _vm.$set(_vm.contactForm, "comments", $$v)
                        },
                        expression: "contactForm.comments",
                      },
                    })
                  : _vm._e(),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }